// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".component .item[data-v-4716662f]{position:absolute;left:0px;right:0px;top:0px;z-index:20}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
